import req from 'utils/req';

import { CourseBody } from '../useCoursesStatus/model';

export async function getCourseStatus(courseId, hostId): Promise<CourseBody> {
  if (!courseId) {
    return null;
  }
  const response = await req(
    `${URL_API_HOST}/api/v1/portfolio/host/${hostId}/course/${courseId}`,
  )
    .get()
    .catch((e) => null);

  return response;
}

export async function updateCourse(
  body: CourseBody,
  hostId: string,
): Promise<CourseBody> {
  const response = await req(
    `${URL_API_HOST}/api/v1/portfolio/host/${hostId}/course/${body.courseId}`,
  )
    .put(body)
    .catch((e) => null);

  return response?.hostCourse ?? body;
}

export async function setStartCourse(
  body: CourseBody,
  hostId: string,
): Promise<CourseBody> {
  const response = await req(
    `${URL_API_HOST}/api/v1/portfolio/host/${hostId}/course`,
  )
    .post(body)
    .catch((e) => null);

  return response?.hostCourse ?? body;
}
